import { render } from "./MetaSection.vue?vue&type=template&id=f78ef3de&scoped=true"
import script from "./MetaSection.vue?vue&type=script&lang=js"
export * from "./MetaSection.vue?vue&type=script&lang=js"

import "./MetaSection.vue?vue&type=style&index=0&id=f78ef3de&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f78ef3de"]])

export default __exports__